import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import type { Organization } from '@/components/AppSidebar'

export const Route = createFileRoute('/_auth')({
  beforeLoad: ({ context, location }) => {
    // If the user is not authenticated, redirect them to the login page
    if (!context.user.isAuthenticated) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href
        }
      })
    }
  },
  loader: ({ context }) => {
    // Create organizations list with current org as first item
    const organizations: Array<Organization> = []
    if (context.user.userOrgProfile) {
      organizations.push(
        {
          slug: context.user.userOrgProfile.org.slug,
          name: context.user.userOrgProfile.org.name
        },
        {
          slug: 'another-org',
          name: 'Another Org'
        }
        // Add more organizations here when multi-org support is added
      )
    }

    return {
      organizations
    }
  },
  component: AuthLayout
})

function AuthLayout() {
  return <Outlet />
}
